import * as m from "@qpr/client-api-base/api/model";
import memoizee from "memoizee";

export const getPeriodLevels = memoizee((id: string) => m.getPeriodLevels(id), {
  //promise: true,
});
